import { Children, Fragment, ReactNode } from 'react';

import { Divider, MetricsBox, SquareMarker, Stack } from '@cast/design-system';

type ChartSummaryMetricProps = {
  color?: string;
  infoTooltip?: ReactNode;
  label: string;
  unit?: ReactNode;
  value: ReactNode;
};

export const ChartSummaryMetric = ({
  color,
  infoTooltip,
  label,
  unit,
  value,
}: ChartSummaryMetricProps) => (
  <MetricsBox
    size="m"
    slots={{
      startContent: color ? <SquareMarker color={color} /> : undefined,
      label,
      infoTooltip,
      value,
      unit,
    }}
  />
);

type ChartSummaryMetricsRowProps = {
  children: ReactNode;
  alwaysRow?: boolean;
};

export const ChartSummaryMetricsRow = ({
  children,
  alwaysRow = false,
}: ChartSummaryMetricsRowProps) => {
  const items = Children.toArray(children);

  return (
    <Stack
      direction={alwaysRow ? 'row' : { none: 'column', laptop: 'row' }}
      alignItems="stretch"
      gap={12}
      sx={{ '& > *:not(.MuiDivider-root)': { flex: 1, minWidth: 0 } }}
    >
      {items.map((child, index) => (
        <Fragment key={index}>
          {index > 0 ? (
            <Divider
              flexItem
              orientation="vertical"
              sx={
                alwaysRow
                  ? undefined
                  : { display: { none: 'none', laptop: 'block' } }
              }
            />
          ) : null}
          {child}
        </Fragment>
      ))}
    </Stack>
  );
};
